export default __webpack_public_path__ + "static/media/DNo.14-4.5c85a42d.jpg";